import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import { IAvailablePackagesResponse } from '../../../entity/interface/iEntitlements';
export interface IAvailablePackagesUseCase {
    execute(apiKey: string, username: string, token: string): Promise<IAvailablePackagesResponse['data']>;
}

export class AvailablePackagesUseCase implements IAvailablePackagesUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get availablePackagesRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string, username: string, token: string): Promise<IAvailablePackagesResponse | any> {
        const response = await this.availablePackagesRepository.availablePackages(apiKey, username, token);
        return response.data;
    }
}
